import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';
@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(private httpService: HttpService) { }

    /**
     * Logins login service
     * @author Starley Cazorla@AOdonto20
     * @param hash_auth
     * @param auth
     * @param credenciais
     * @returns
     */
    async login(hash_auth: any, auth: any, credenciais: any) {
        let config = this.httpService.setHeaderConfig(false, {
            "hash_auth": hash_auth,
            "auth": auth
        });
        return lastValueFrom(this.httpService.post(UrlConnectionEnum.LOGIN, new HttpParams({ fromObject: credenciais }), config));
    }

}
